/* eslint-disable react/jsx-filename-extension */
/* eslint-disable require-jsdoc */
/* eslint-disable import/prefer-default-export */
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2022. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React from 'react';
import { useMsal } from '@azure/msal-react';
import Button from '@govhhs/govhhs-design-system-react/lib/components/Button';
import { Authentication } from '@spm/universal-access';
import PATHS from '@spm/universal-access-ui/src/router/Paths';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { msalConfig } from '../../authConfig';
import { ID } from '../ApplicationHeader/constants';

/**
 * SD-7277
 * Creates a button that kicks of the logout process
 * @returns
 */
const SDMFALogoutButton = data => {
  const { history } = data;
  const marginDirection = document.dir === 'rtl' ? { marginRight: 'auto' } : { marginLeft: 'auto' };
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const handleLogout = logoutType => {
    // If loginType is redirect, use loginRedirect() to start process
    if (logoutType === 'redirect') {
      // This call to instance.logoutRedirect clears the MSAL cache, then hands off to the Azure
      // Server to clear the session on their end.
      history.push(PATHS.HOME);
      instance
        .logoutRedirect({
          account: activeAccount,
          postLogoutRedirectUri: msalConfig.auth.postLogoutRedirectURI,
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {});
      // Clear our local storage then do the CEP logout.
      // Done outside of the then() function since the logout promise is not expected to resolve.
      sessionStorage.clear();
      Authentication.logout();
    }
    // Same as above, but via popup instead of via redirect
    if (logoutType === 'popup') {
      instance
        .logoutPopup({
          account: activeAccount,
          postLogoutRedirectUri: msalConfig.auth.redirectURI,
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {});
      // Clear our local storage then do the CEP logout.
      // Done outside of the then() function since the logout promise is not expected to resolve.
      sessionStorage.clear();
      Authentication.logout();
    }
  };
  // Renders a button using redirect
  // Can be changed to popup if desired
  return (
    <Button
      key="logout"
      category="secondary"
      className="wds-u-mr--small"
      data-testid={ID.PROFILE_MENU_LOGOUT_BUTTON_ID}
      onClick={() => handleLogout('redirect')}
      size="small"
      style={marginDirection}
    >
      Log Out
    </Button>
  );
};

export default withRouter(injectIntl(SDMFALogoutButton));
